"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const icons_1 = require("@dialogexe/cw-asset-provider/icons");
const moment = require("moment");
/** TODO: Some how, these constants must be aligned with metadata.json data attribute of mode **/
const MODE_SINGLE_RANDOM = 'single_random';
const MODE_SINGLE_FIXED = 'single_fixed';
const MODE_DEFAULT = 'default';
const NORMAL = "normal";
const OPEN = "open";
class Slideshow extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            previous: null,
            current: 0
        };
        this.touchDeltaTreshold = 50;
        this.lastTouch = null;
        this.touchDelta = 0;
        this.touchEnded = false;
        this.changing = false;
        this.direction = 1;
        this.sortByDate = (sortDate) => {
            if (sortDate) {
                return moment(sortDate).isSameOrAfter(moment(), 'day');
            }
            return true;
        };
        this.hideBuyLinkForOpenArrangements = (slide, link) => {
            const { ticketSaleType } = slide;
            return ticketSaleType !== OPEN || link.path.indexOf('tickets') === -1;
        };
    }
    get activeSlides() {
        const { mode } = this.props;
        const slidesWithImage = this.props.slides
            .filter(s => s.image && this.sortByDate(s.sortDate));
        const slides = this.uniqueSlides(slidesWithImage, "image")
            .sort((a, b) => this.sorter(a, b))
            .slice(0, this.props.limit);
        if (slides.length === 0) {
            return [];
        }
        switch (mode) {
            case MODE_SINGLE_FIXED: {
                return [slides[0]];
            }
            case MODE_SINGLE_RANDOM: {
                return [slides[this.getRandomInt(0, slides.length - 1)]];
            }
            default: {
                return slides;
            }
        }
    }
    componentWillMount() {
        this.startInterval();
    }
    componentWillUnmount() {
        clearInterval(this.intervalHandle);
    }
    render() {
        const { mode } = this.props;
        const slides = this.activeSlides;
        if (slides.length === 0) {
            return React.createElement("div", null);
        }
        return (React.createElement("div", { className: "Slideshow", onTouchMove: this.onTouchMove.bind(this), onTouchEnd: this.onTouchEnd.bind(this) },
            slides.map((slide, index) => (React.createElement("i", { key: index, className: `slide ${slides.length > 1 ? this.getClass(index) : ''}`, style: { backgroundImage: `url("${slide.image}")` }, onTransitionEnd: this.removeClass.bind(this) }))),
            React.createElement("div", { className: "container" },
                slides.length > 1 && mode === MODE_DEFAULT && (React.createElement("div", { className: "navigation is-hidden-touch" },
                    React.createElement("button", { className: "icon-button is-large", onClick: this.previous.bind(this) },
                        React.createElement("img", { src: icons_1.arrowLeftWhiteIcon, alt: "" })),
                    React.createElement("button", { className: "icon-button is-large", onClick: this.next.bind(this) },
                        React.createElement("img", { src: icons_1.arrowRightWhiteIcon, alt: "" })))),
                slides.map((slide, index) => (React.createElement("div", { key: index, className: `slide-info ${slides.length > 1 ? this.getClass(index) : 'fixed'}`, onTransitionEnd: this.removeClass.bind(this) },
                    React.createElement("h2", { className: "slide-meta" },
                        slide.metaPrefix,
                        " ",
                        this.formatMeta(slide.meta)),
                    React.createElement("h1", { className: "slide-title" }, slide.title),
                    React.createElement("div", { className: "slide-actions group is-narrow" }, slide.links.map((link, index) => (link !== null && link.label != "") && this.hideBuyLinkForOpenArrangements(slide, link) && (React.createElement("a", { key: index, className: `button is-contained is-wide ${link.primary ? 'is-primary' : ''}`, href: link.path }, link.label))))))),
                slides.length > 1 && mode === MODE_DEFAULT && (React.createElement("div", { className: "dot-navigation" }, slides.map((slide, index) => (React.createElement("i", { key: index, className: `${this.state.current === index ? 'active' : ''}`, onClick: this.moveTo.bind(this, index, 1) }))))))));
    }
    onTouchMove(e) {
        if (this.touchEnded) {
            return;
        }
        const touch = e.changedTouches.item(0);
        if (!this.lastTouch) {
            this.touchDelta = 0;
            this.lastTouch = touch;
            return;
        }
        this.touchDelta = this.touchDelta + (this.lastTouch.clientX - touch.clientX);
        this.lastTouch = touch;
        if (this.touchDelta > this.touchDeltaTreshold) {
            this.touchEnded = true;
            return this.next();
        }
        if (this.touchDelta < -(this.touchDeltaTreshold)) {
            this.touchEnded = true;
            return this.previous();
        }
    }
    onTouchEnd() {
        this.touchEnded = false;
        this.lastTouch = null;
        this.touchDelta = 0;
    }
    resetInterval() {
        if (this.intervalHandle) {
            clearInterval(this.intervalHandle);
        }
        this.startInterval();
    }
    startInterval() {
        this.intervalHandle = setInterval(this.next.bind(this), this.props.interval);
    }
    previous() {
        const current = this.state.current - 1 < 0 ? this.activeSlides.length - 1 : this.state.current - 1;
        this.moveTo(current, -1);
    }
    next() {
        const current = this.state.current + 1 >= this.activeSlides.length ? 0 : this.state.current + 1;
        this.moveTo(current, 1);
    }
    moveTo(index, direction) {
        if (this.changing) {
            return;
        }
        if (this.state.current === index) {
            return;
        }
        this.changing = true;
        this.direction = direction;
        this.setState({
            current: index,
            previous: this.state.current
        });
        this.resetInterval();
    }
    getClass(index) {
        if (this.direction > 0 && this.state.current === index) {
            return 'next-left';
        }
        if (this.direction < 0 && this.state.current === index) {
            return 'next-right';
        }
        if (this.direction > 0 && this.state.previous === index) {
            return 'previous-left';
        }
        if (this.direction < 0 && this.state.previous === index) {
            return 'previous-right';
        }
        return '';
    }
    removeClass(e) {
        this.changing = false;
        this.direction = 1;
        e.target.classList.remove('previous-left');
        e.target.classList.remove('previous-right');
    }
    formatMeta(meta) {
        return moment(meta).isValid() ? moment(meta).format('LL') : meta;
    }
    getRandomInt(min, max) {
        return Math.floor(min + (max - min) * Math.random());
    }
    sorter(a, b) {
        const { sortAsc } = this.props;
        if (!a.sortDate || !b.sortDate) {
            return 0;
        }
        return sortAsc
            ? moment(a.sortDate).unix() - moment(b.sortDate).unix()
            : moment(b.sortDate).unix() - moment(a.sortDate).unix();
    }
    uniqueSlides(myArr, prop) {
        return myArr.filter((obj, pos, arr) => {
            return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
        });
    }
}
exports.Slideshow = Slideshow;
exports.default = Slideshow;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-slideshow/Slideshow.tsx